// ── 8bitbrain Email Popup ──
// Form submits natively to Shopify /contact (form 'customer' tag),
// Shopify redirects back with ?customer_posted=true and form.posted_successfully? = true,
// which sets window.__popupSubscribeSuccess in the liquid. This script reacts to it.

document.addEventListener('DOMContentLoaded', async function() {
  var popup = document.getElementById('email-popup');
  var overlay = document.getElementById('popup-overlay');
  var corner = document.getElementById('popup-corner');
  if (!popup) return;

  // ── Case 1: user just subscribed successfully (redirected back from Shopify) ──
  if (window.__popupSubscribeSuccess) {
    popup.classList.add('open');
    popup.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('open');
    sessionStorage.setItem('8bb_popup_done', '1');

    // If freepack mode · add the free product to cart
    if (window.__popupSubscribeMode === 'freepack') {
      var variantId = window.__popupSubscribeVariant;
      if (variantId && variantId !== '0' && variantId !== 0) {
        try {
          if (typeof window.addToCart === 'function') {
            // Goes through the cart queue: never adds a pack that is already in the bag, quantity stays 1.
            window.addToCart(parseInt(variantId, 10), null);
          } else {
            var cur = await (await fetch('/cart.js')).json();
            var vid = parseInt(variantId, 10);
            var have = (cur.items || []).some(function(it) { return it.variant_id === vid; });
            if (!have) {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: vid, quantity: 1 })
              });
            }
            if (typeof refreshCart === 'function') {
              refreshCart();
            }
          }
        } catch (e) {
          console.log('[popup] Free pack add to cart failed:', e);
        }
      }
    }

    // Clean ?customer_posted=true from URL so refresh does not keep it
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.has('customer_posted')) {
        url.searchParams.delete('customer_posted');
        var clean = url.pathname + (url.search || '') + url.hash;
        window.history.replaceState({}, document.title, clean);
      }
    } catch (e) {}
    return;
  }

  // ── Case 2: Shopify returned form errors (email invalid / already taken) · keep popup open ──
  if (window.__popupSubscribeError) {
    popup.classList.add('open');
    popup.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('open');
    return;
  }

  // ── Case 3: already shown this session · show corner badge only ──
  if (sessionStorage.getItem('8bb_popup_done')) {
    if (corner) corner.style.display = 'block';
    return;
  }

  // ── Case 4: normal flow · show popup after delay ──
  // Desktop: at least 10s after the page is ready, and only once the visitor has touched the page
  // (click, key, wheel; window.__bbInput from email-popup.liquid). Until that first input the browser is
  // still choosing the page's largest paint for Core Web Vitals, and a popup opened then became it
  // (8-10s LCP). It also waits for a calm moment so it never lands on a click in progress.
  // Phones keep their own gate in email-popup.liquid (it parks data-delay at 86400).
  var delay = Math.max(parseInt(popup.dataset.delay, 10) || 5, 10) * 1000;
  var inp = window.__bbInput;
  if (!inp) {
    inp = window.__bbInput = { first: 0, last: 0 };
    ['pointerdown', 'mousedown', 'touchstart', 'keydown', 'wheel'].forEach(function(ev) {
      window.addEventListener(ev, function() { var n = Date.now(); if (!inp.first) inp.first = n; inp.last = n; }, { passive: true, capture: true });
    });
  }
  function openWhenCalm() {
    // Never cover a Buy Now redirect or a cart drawer the visitor just opened.
    var drawer = document.getElementById('cart-drawer');
    if ((typeof bbLeaving !== 'undefined' && bbLeaving) || (drawer && drawer.classList.contains('open'))) {
      setTimeout(openWhenCalm, 3000);
      return;
    }
    try { if (sessionStorage.getItem('8bb_popup_done')) return; } catch (e) {}
    if (popup.classList.contains('open')) return;
    var ae = document.activeElement;
    if (document.hidden || !inp.first || Date.now() - inp.last < 2000 || (ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName))) {
      setTimeout(openWhenCalm, 1000);
      return;
    }
    popup.classList.add('open');
    popup.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('open');
  }
  setTimeout(openWhenCalm, delay);
});

function closePopup() {
  var popup = document.getElementById('email-popup');
  var overlay = document.getElementById('popup-overlay');
  var corner = document.getElementById('popup-corner');
  if (popup) {
    // move focus out first: a focused button inside an aria-hidden popup is blocked by the browser
    if (popup.contains(document.activeElement) && document.activeElement.blur) document.activeElement.blur();
    popup.classList.remove('open');
    popup.setAttribute('aria-hidden', 'true');
  }
  if (overlay) overlay.classList.remove('open');
  if (corner) corner.style.display = 'block';
  sessionStorage.setItem('8bb_popup_done', '1');
}

function reopenPopup() {
  var popup = document.getElementById('email-popup');
  var overlay = document.getElementById('popup-overlay');
  var corner = document.getElementById('popup-corner');
  if (popup) { popup.classList.add('open'); popup.setAttribute('aria-hidden', 'false'); }
  if (overlay) overlay.classList.add('open');
  if (corner) corner.style.display = 'none';
}

function copyCode(el) {
  var code = el.dataset.code;
  var copySpan = el.querySelector('.code-copy');
  navigator.clipboard.writeText(code).then(function() {
    if (copySpan) {
      copySpan.textContent = 'COPIED!';
      setTimeout(function() { copySpan.textContent = 'COPY'; }, 2000);
    }
  }).catch(function() {});
}